module.exports = __webpack_public_path__ + "cb83edb5a834f9ebeb9dc0c7f9ba21df.png";